<template>
  <v-app id="detalle-solicitud-amex">
    <v-dialog v-model="dialogDetalleAmex" fullscreen hide-overlay :persistent="true"
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-center">Detalle de Solicitud AMEX: {{ detalleAMEX.idsolicitud_amex
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar> <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- Columna: Datos Generales -->
              <v-flex xs12 sm12 md6>
                <h3 class="grey--text">Datos Generales</h3><br />
                <v-text-field v-model="detalleAMEX.empresa.nombre" label="Empresa" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.descripcion" label="Concepto" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.centro_costo.nombre" label="Centro de costos" box
                  disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.direccion.nombre" label="UEN / Plaza" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.departamento.nombre" label="Departamento" box
                  disabled></v-text-field>

                <br />
                <h3 class="grey--text">Información adicional</h3><br />
                <v-text-field :value="formatDateTimeCDMX(detalleAMEX.fecha_creacion)" label="Fecha de solicitud" box
                  disabled></v-text-field>
                <v-text-field :value="`${detalleAMEX.usuario_creacion.nombre} (${detalleAMEX.usuario_creacion.puesto})`"
                  label="Solicitante" box disabled></v-text-field>

              </v-flex>

              <!-- Columna: Datos de Pago -->
              <v-flex xs12 sm12 md6>
                <h3 class="grey--text">Datos de Pago</h3><br />
                <v-text-field
                  :value="detalleAMEX.estados_cuenta.length > 0 ? detalleAMEX.estados_cuenta[0].proveedor : ''"
                  label="Proveedor" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.descripcion" label="Descripción" box disabled></v-text-field>
                <v-text-field :value="formatDateLong(detalleAMEX.fecha_pago)" label="Fecha de Pago" box disabled />
                <v-text-field :value="formatCurrency(detalleAMEX.saldo_a_pagar)" label="Saldo a Pagar" box disabled />
              </v-flex>
            </v-layout>
            <h3 class="grey--text">Estados de Cuenta Asociados</h3><br />
            <v-data-table :headers="headersDetalleEdc" :items="detalleAMEX.estados_cuenta" class="elevation-1"
              hide-default-footer>
              <template slot="items" slot-scope="{ item }">
                <tr>
                  <td>{{ formatDateShort(item.fecha_corte) }}</td>
                  <td>{{ formatDateShort(item.fecha_pago) }}</td>
                  <td>{{ formatPeriodo(item.periodo) }}</td>
                  <td>{{ item.tarjetahabiente }}</td>
                  <td>{{ item.asistente }}</td>
                  <td>{{ formatCurrency(item.saldo_a_pagar) }}</td>
                </tr>
              </template>
            </v-data-table>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" right>
      {{ msgError }}
    </v-snackbar>
  </v-app>
</template>

<script>
import services from "@/config/services";
import axios from "axios";

export default {
  name: "DetalleSolicitudAMEX",
  data() {
    return {
      loading: false,
      success: false,
      error: false,
      msgSuccess: "",
      msgError: "",
      dialogDetalleAmex: false,
      detalleAMEX: {
        idsolicitud_amex: null,
        codigo: '',
        descripcion: '',
        empresa: { nombre: '' },
        centro_costo: { nombre: '' },
        direccion: { nombre: '' },
        departamento: { nombre: '' },
        tarjetahabiente: { nombre: '' },
        usuario_creacion: { nombre: '' },
        usuario_actualizacion: { nombre: '' },
        estatus: { nombre: '' },
        fecha_creacion: '',
        fecha_pago: '',
        saldo_a_pagar: '0.00',
        importe_comprobado: '0.00',
        estados_cuenta: []
      },
      headersDetalleEdc: [
        { text: 'Fecha Corte', value: 'fecha_corte', sortable: false },
        { text: 'Fecha Pago', value: 'fecha_pago', sortable: false },
        { text: 'Periodo', value: 'periodo', sortable: false },
        { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false },
        { text: 'Asistente', value: 'asistente', sortable: false },
        { text: 'Saldo a Pagar', value: 'saldo_a_pagar', sortable: false }
      ]
    };
  },
  async mounted() {
    const idsolicitud = this.$route.params.idsolicitud;
    if (idsolicitud) {
      await this.showDetailAmex(idsolicitud);
    }
  },
  methods: {
    closeDetailRep() {
      this.dialogDetalleAmex = false;
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${pad(d.getFullYear())}`;
    },
    formatDateTimeCDMX(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${pad(d.getFullYear())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatPeriodo(periodo) {
      if (!periodo) return '';
      const ano = periodo.substring(0, 4);
      const mes = periodo.substring(4, 6);
      return `${mes}/${ano}`;
    },
    formatDateLong(date) {
      if (!date) return '';
      const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      const mes = meses[d.getMonth()];
      return `${pad(d.getDate())}-${mes}-${d.getFullYear()}`;
    },
    async showDetailAmex(idsolicitud) {
      try {
        this.loading = true;
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.amexSolicitudesDetalle.replace(":idsolicitud_amex", idsolicitud);

        const response = await axios.get(url, { headers });
        const data = response.data;

        // Mapear la respuesta al objeto detalleAMEX
        this.detalleAMEX = {
          idsolicitud_amex: data.idsolicitud_amex,
          codigo: data.codigo,
          descripcion: data.descripcion,
          fecha_creacion: data.fecha_creacion,
          fecha_pago: data.fecha_pago,
          saldo_a_pagar: data.saldo_a_pagar,
          importe_comprobado: data.importe_comprobado,
          empresa: data.empresa,
          centro_costo: data.centro_costo,
          direccion: data.direccion,
          departamento: data.departamento,
          tarjetahabiente: data.tarjetahabiente,
          usuario_creacion: data.usuario_creacion,
          usuario_actualizacion: data.usuario_actualizacion,
          estatus: data.estatus,
          estados_cuenta: data.estados_cuenta || []
        };

        this.dialogDetalleAmex = true;
      } catch (err) {
        this.error = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
        console.error("Error al cargar detalle AMEX:", err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.grey--text {
  font-weight: 500;
}
</style>
